import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class ProjectStore {
    loading = false;
    total = 0;
    projectList = [];
    assignDriver = [];
    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            loading: observable,
            total: observable,
            projectList: observable,
            assignDriver: observable,
            getProjectDetails: action,
            addProjectData: action,
            getProjectDetails: action,
            getAssignDrivers: action,
            deleteRecord: action,
            addProjectData: action,
        });
        this.rootStore = rootStore;
    }


    async getProjectDetails(companyId, projectId) {
        var postData = { companyId: companyId, projectId: projectId };
        console.log(postData)
        const base64Input = await base64_encode(JSON.stringify(postData));

        const response = await postApi
            .getClient("")
            // .get("http://localhost:3010/project/getProject", {
            .get(config.NodeUrl + "/project/getProject", {
                params: postData,
            });
        this.projectList = response?.data?.data;
        console.log(response?.data?.data);

        return response?.data?.data;
    }

    // To add project details
    async addProjectData(postData) {
        var projectDetails = { postData };

        var response = await postApi
            .getClient("")
            // .post("http://localhost:3010/project/addProject", projectDetails);
            .post(config.NodeUrl + "/project/addProject", projectDetails);

        return response?.data;
    }


    async deleteRecord({ id }) {
        const postData = {
            id: id,
        };
        const base64Input = await base64_encode(JSON.stringify(postData));

        var response = await postApi
            .getClient()
            // .delete("http://localhost:3010/project/deleteProject", {
            .delete(config.NodeUrl + "/project/deleteProject", {
                params: {
                    projectId: id,
                },
            });

        return response;
    }
    async assignProject(data) {

        const response = await postApi
            .getClient("")
            .post(config.NodeUrl + "/project/assignProject", data);
        // .post("http://localhost:3010/project/assignProject", data);
        return response;
    }
    async getAssignDrivers(projectId) {

        const response = await postApi
            .getClient("")
            .get(config.NodeUrl + "/project/getAssignDrivers", {
                // .get("http://localhost:3010/project/getAssignDrivers", {
                params: {
                    projectId: projectId,
                },
            });
        this.assignDriver = response?.data?.data;
        return response?.data?.data;
    }
}

export default ProjectStore;
